export default __webpack_public_path__ + "197213592de7a2a62e0699fa36095221.woff";